import BTModal from "react-bootstrap/Modal";
import CloseButton from "react-bootstrap/CloseButton";
import PropTypes from "prop-types";

import { ModalContainer } from "./Modal.styles";

export const Modal = ({
  show = true,
  onHide,
  heading,
  className = "",
  size = "md",
  headingClass = "",
  showClose = true,
  ...props
}) => {
  return (
    <ModalContainer
      size={size}
      className={["modal-wrapper", className].join(" ")}
      animation={false}
      show={show}
      onHide={onHide}
      centered
      {...props}
    >
      {heading ? (
        <BTModal.Header closeButton>
          <BTModal.Title className={["body-heading", headingClass].join(" ")}>
            {heading}
          </BTModal.Title>
        </BTModal.Header>
      ) : (
        showClose && <CloseButton onClick={onHide} data-close-modal="true" />
      )}

      <BTModal.Body>{props.children}</BTModal.Body>
    </ModalContainer>
  );
};

Modal.propTypes = {
  heading: PropTypes.node,
  size: PropTypes.string,
  show: PropTypes.bool,
  showClose: PropTypes.bool,
  onHide: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  headingClass: PropTypes.string,
};
